import { render, staticRenderFns } from "./CourseSubpackInterestModal.vue?vue&type=template&id=131203cc&scoped=true&"
import script from "./CourseSubpackInterestModal.vue?vue&type=script&lang=ts&"
export * from "./CourseSubpackInterestModal.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSubpackInterestModal.vue?vue&type=style&index=0&id=131203cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131203cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('131203cc', component.options)
    } else {
      api.reload('131203cc', component.options)
    }
    module.hot.accept("./CourseSubpackInterestModal.vue?vue&type=template&id=131203cc&scoped=true&", function () {
      api.rerender('131203cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/CourseSubpackInterestModal.vue"
export default component.exports